import trySaveMessage from './trySaveMessage';
import { findComposePlugins } from '../plugins/ComposePlugins';
import { ComposeViewState } from 'owa-mail-compose-store';
import formatTextToHTML from '../utils/formatTextToHTML';
import getCloudyAttachmentNames from '../utils/getCloudyAttachmentNames';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { IContentOperationPlugin } from 'owa-editor-plugins-list';
import loc from 'owa-localize';
import { action } from 'satcheljs/lib/legacy';
import {
    switchToPlainTextCloudAttachmentWarning,
    switchToPlainTextWarning,
} from './switchBodyType.locstring.json';

export default action('switchBodyType')(async function switchBodyType(viewState: ComposeViewState) {
    const contentOperationPlugin = findComposePlugins(viewState).contentOperation;
    const isPlainText = viewState.bodyType == 'Text';

    if (!isPlainText && getCloudyAttachmentNames(viewState).length > 0) {
        await confirm(
            null /*title*/,
            loc(switchToPlainTextCloudAttachmentWarning),
            false /*resolveImmediately*/,
            {
                hideCancelButton: true,
            }
        );
    } else {
        const isEmpty = contentOperationPlugin.isEmpty();
        const resolveImmediately = isPlainText || isEmpty;

        if (
            (await confirm(null, loc(switchToPlainTextWarning), resolveImmediately)) ==
            DialogResponse.ok
        ) {
            if (viewState.bodyType == 'HTML') {
                convertHtmlToText(viewState, contentOperationPlugin);
            } else {
                convertTextToHtml(viewState);
            }
        }
    }
});

async function convertHtmlToText(viewState: ComposeViewState, plugin: IContentOperationPlugin) {
    if (plugin) {
        // Remove inline images and save
        plugin.removeInlineImage();
        plugin.updateContentToViewState();
        plugin.stopSaveOnDispose();
        trySaveMessage(viewState, true /*isAutoSave*/);

        viewState.content = plugin.getTextContent();
        viewState.bodyType = 'Text';
        viewState.isRibbonShown = false;
        viewState.docking.isBottomDocking = false;
        viewState.isDirty = true;
    }
}

function convertTextToHtml(viewState: ComposeViewState) {
    viewState.bodyType = 'HTML';
    let content = viewState.content;
    viewState.content = formatTextToHTML(content);
    viewState.isRibbonShown = true;
    viewState.isDirty = true;
}
